import * as React from 'react';
import { IconActionChevronDownSmall16, IconActionChevronUpSmall16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './ExpandButton.css';
import { TextButton } from '../TextButton';

export interface IExpandButtonProps {
  expanded: boolean;
  onToggle(): void;
  expandText?: string;
  collapseText?: string;
}

export const ExpandButton: React.FC<IExpandButtonProps> = ({
  expanded,
  onToggle,
  expandText = 'Показать ещё',
  collapseText = 'Свернуть',
}) => {
  return (
    <div className={styles['button']}>
      <TextButton onClick={onToggle}>
        {expanded ? collapseText : expandText}
        <span className={styles['icon']}>
          {expanded ? (
            <IconActionChevronUpSmall16 color="icon-main-default" />
          ) : (
            <IconActionChevronDownSmall16 color="icon-main-default" />
          )}
        </span>
      </TextButton>
    </div>
  );
};
